import { addLead } from "../services/api.js";

document.addEventListener("DOMContentLoaded", () => {
    const inquiryForm = document.getElementById("inquiryForm");
    if (!inquiryForm) return;

    const inquiryName = document.getElementById("inquiryName");
    const inquiryEmail = document.getElementById("inquiryEmail");
    const inquiryPhone = document.getElementById("inquiryPhone");
    const inquirySchool = document.getElementById("inquirySchool");
    const inquiryRemarks = document.getElementById("inquiryRemarks");

    inquiryForm.addEventListener("submit", async (event) => {
        event.preventDefault();

        if (!validateForm()) return;

        const submitButton = inquiryForm.querySelector("[type='submit']");
        submitButton.classList.add("loading");

        const payload = {
            name: inquiryName.value.trim(),
            email: inquiryEmail.value.trim(),
            phone_number: inquiryPhone.value.trim(),
            school_name: inquirySchool.value.trim(),
            leads_remarks: inquiryRemarks.value.trim(),
        };

        try {
            let cleanPayload = removeEmptyValues(payload)
            const res = await addLead(cleanPayload); // await API call
            console.log("API Response:", res);

            if (Object.keys(res).length > 0) {
                Swal.fire({
                    text: "Form submitted successfully!",
                    icon: "success",
                    showConfirmButton: false,
                    timer: 3000,
                });
                inquiryForm.reset();
            }
        } catch (error) {
            console.log("API Error:", error);
        } finally {
            submitButton.classList.remove("loading");
        }
    });

    // 🔁 Real-time validation
    inquiryForm.addEventListener("input", (event) => {
        const target = event.target;
        if (target.tagName.toLowerCase() === "input") {
            validateField(target);
        }
    });

    // =========================
    // ✅ Validation Functions
    // =========================
    function validateForm() {
        let isValid = true;
        [inquiryName, inquiryEmail, inquiryPhone, inquirySchool].forEach((field) => {
            isValid = validateField(field) && isValid;
        });
        return isValid;
    }

    function validateField(field) {
        const fieldName = field.name;
        const fieldValue = field.value.trim();
        const errorSpan = document.getElementById(`inquiry${capitalize(fieldName)}Error`);
        const formControl = field.parentElement;

        errorSpan.textContent = "";
        formControl.classList.remove("error");

        if (!fieldValue) {
            errorSpan.textContent = `${capitalize(fieldName)} is required`;
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "name" && !isValidName(fieldValue)) {
            errorSpan.textContent = "Invalid name";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "email" && !isValidEmail(fieldValue)) {
            errorSpan.textContent = "Invalid email address";
            formControl.classList.add("error");
            return false;
        }

        if (fieldName === "phone" && !isValidMobile(fieldValue)) {
            errorSpan.textContent = "Invalid mobile number";
            formControl.classList.add("error");
            return false;
        }

        return true;
    }

    function isValidName(name) {
        return /^[a-zA-Z\s]{3,}$/.test(name);
    }

    function isValidEmail(email) {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }

    function isValidMobile(mobile) {
        return /^(\+91[\-\s]?)?[0]?(91)?[6789]\d{9}$/.test(mobile);
    }

    function capitalize(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    function removeEmptyValues(obj) {
        return Object.fromEntries(
            Object.entries(obj).filter(([_, value]) => {
                // Define what constitutes an "empty" value
                // This example considers null, undefined, and empty strings as empty
                if (value === null || value === undefined || value === '') {
                    return false;
                }
                return true;
            })
        );
    };
});
